module.exports = __webpack_public_path__ + "img/ilustracion_error-01.dcde7254.svg";